import { useParams } from 'react-router-dom';
import './App.css';

import CoverSection1 from './components/CoverSection1';
import FooterSection from './components/FooterSection';
import IntroSection2 from './components/IntroSection2';
import PhotoGalery3 from './components/PhotoGalery3';
import TabBar from './components/TabBar';
import Verse6 from './components/Verse6';
import WeddingDetails4 from './components/WeddingDetails4';
import Wishes5 from './components/Wishes5';
import { useEffect, useState } from 'react';
import { BarLoader } from 'react-spinners';
import logo from './assets/logo.png';

/*images*/
import iBg3 from './assets/bg3.jpg';
import iAnd from './assets/and.png';
import iLogo from './assets/logo.png';
import Img1 from './assets/gallery/1.jpg';
import Img2 from './assets/gallery/2.jpg';
import Img3 from './assets/gallery/3.jpg';
import Img4 from './assets/gallery/4.jpg';
import Img5 from './assets/gallery/5.jpg';
import Img6 from './assets/gallery/6.jpg';
import Img7 from './assets/gallery/7.jpg';
import Img8 from './assets/gallery/8.jpg';
import Img9 from './assets/gallery/9.jpg';
import Img10 from './assets/gallery/10.jpg';
//

const BASE_URL = 'https://getrowbyid-j3vs5nbufq-uc.a.run.app';
const GET_INVITE_BY_ID_PATH = '/getRowById';

function App() {
    const { id } = useParams();
    const [fullName, setFullName] = useState('');
    const [pax, setPax] = useState(0);
    const [wishes, setWishes] = useState([]);
    const [inviteType, setInviteType] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [errMessage, setErrMessage] = useState('');

    async function fetchInvite() {
        try {
            setIsLoading(true);
            const response = await fetch(`${BASE_URL}${GET_INVITE_BY_ID_PATH}/${id}`);
            const data = await response.json();

            if (data.error) throw data.error;

            const rsvpHolmatTemp = toNumberOrNull(data.rsvp_holmat);
            const rsvpReceptionTemp = toNumberOrNull(data.rsvpReceptionTemp);

            setFullName(data.full_name || '');
            setPax(data.pax || 0);
            setWishes(shuffleArray(data.wishes || []));
            setInviteType(data.invitation_type || '');
            setIsSubmitted(rsvpHolmatTemp !== null || rsvpReceptionTemp !== null);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching invite data:', error);
            setIsError(true);
            setErrMessage(error);
        }
    }

    function toNumberOrNull(value) {
        if (value === null || value === undefined || value === '') return null;
        const num = Number(value);
        return isNaN(num) ? null : num;
    }

    const preloadImages = (images) => {
        images.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    };

    useEffect(() => {
        if (id) {
            preloadImages([iBg3, iAnd, iLogo, Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8, Img9, Img10]);
            fetchInvite();
        }
    }, [id]);

    const shuffleArray = (array) => {
        // Create a copy of the original array to avoid modifying it directly
        const result = [...array];

        // Fisher-Yates shuffle algorithm
        for (let i = result.length - 1; i > 0; i--) {
            // Pick a random index from 0 to i
            const j = Math.floor(Math.random() * (i + 1));

            // Swap elements at indices i and j
            [result[i], result[j]] = [result[j], result[i]];
        }

        return result;
    };

    if (isError)
        return (
            <div
                style={{
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    backgroundColor: '#ede9e3',
                    padding: '64px',
                    flexDirection: 'column',
                    gap: '16px',
                }}
            >
                <img src={logo} className="logo" alt="logo" style={{ width: '100px' }} />
                <p stlye="cLight">Something went wrong, please contact the person who sent you this link</p>
                <p stlye="cLight">{errMessage}</p>
            </div>
        );

    if (isLoading)
        return (
            <div
                style={{
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#ede9e3',
                    padding: '64px',
                }}
            >
                <BarLoader color="#35372c" />
            </div>
        );

    return (
        <div className="App">
            <TabBar fetchInvite={fetchInvite} inviteType={inviteType} id={id} isSubmitted={isSubmitted} pax={pax} />
            <CoverSection1 fullName={fullName} />
            <IntroSection2 />
            <PhotoGalery3 />
            <WeddingDetails4 inviteType={inviteType} />
            <Wishes5 wishes={wishes} />
            <Verse6 />
            <FooterSection />
        </div>
    );
}

export default App;
